<div
  class="bg-primary-on box-border flex min-h-24 w-full items-stretch text-base [overflow-wrap:anywhere] [hyphens:auto]"
  [attr.lang]="languageService.activeLanguage().prefix.toLowerCase()"
  [ngClass]="{
    'cursor-not-allowed opacity-60': ngControl.control!.disabled,
  }">
  @let hasError = ngControl.errors && ngControl.touched;
  <div class="relative w-full bg-inherit">
    <div
      class="border-input-ring border-input rounded-input peer p-input min-h-28 w-full bg-transparent placeholder-transparent focus:ring-0">
      <quill-editor
        class="test h-full w-full"
        format="json"
        [id]="id()"
        [placeholder]="label() ?? ''"
        [attr.data-testid]="id() | appendTestId: 'editor'"
        [formControl]="editorControl"></quill-editor>
    </div>
    <label
      [attr.data-testid]="id() | appendTestId: 'label'"
      [for]="id()"
      [ngClass]="{
        'text-input-error': hasError,
      }"
      class="peer-placeholder-shown:text-input-label peer-focus:text-input-focus pointer-events-none absolute -top-2 left-4 cursor-text bg-inherit text-sm transition-all peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-base peer-focus:-top-2 peer-focus:text-sm">
      {{ formattedLabel() }}
    </label>
    @if (hasError && !errorTemplate()) {
      <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
        <ng-content></ng-content>
      </aw-error-message>
    }
    @if (hasError && errorTemplate()) {
      <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
        <ng-container *ngTemplateOutlet="errorTemplate()!"></ng-container>
      </aw-error-message>
    }
  </div>
</div>
